import React from 'react'
import { PageHeader } from "antd";
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb';
import ChangePassComp from '../../components/changePasswordComp/ChangePassComp';

const ChangePassword = () => {
    return (
        <div className="inside-main-content">
            <AdminBreadCrumb />

            <div className="box-style">
                <PageHeader
                    ghost={false}
                    onBack={() => window.history.back()}
                    title="Change Password"
                    subTitle=""
                    extra={[]}
                ></PageHeader>
                
                <ChangePassComp />

            </div>
        </div>
    )
}

export default ChangePassword